export default "__VITE_ASSET__Bm32X2OG__"